import { useCallback, useEffect, useState } from 'react';
import axiosInstance from '../../utils/axiosConfig';
import { RandevuTanimlar } from './randevuOrtak';

// Randevu tanımları (türler, kaynaklar, personel) — sayfa / modallar arasında paylaşılan kısa ömürlü önbellek
let onbellek: { zaman: number; veri: RandevuTanimlar } | null = null;
let bekleyen: Promise<RandevuTanimlar> | null = null;
const dinleyiciler = new Set<(v: RandevuTanimlar) => void>();

export async function randevuTanimlariGetir(yenile = false): Promise<RandevuTanimlar> {
    if (!yenile && onbellek && Date.now() - onbellek.zaman < 5 * 60 * 1000) return onbellek.veri;
    if (!yenile && bekleyen) return bekleyen;
    bekleyen = axiosInstance.get('/api/Randevular/tanimlar').then(r => {
        onbellek = { zaman: Date.now(), veri: r.data };
        dinleyiciler.forEach(f => f(r.data));
        return r.data as RandevuTanimlar;
    }).finally(() => { bekleyen = null; });
    return bekleyen;
}

export function useRandevuTanimlar() {
    const [tanimlar, setTanimlar] = useState<RandevuTanimlar | null>(onbellek?.veri ?? null);
    useEffect(() => {
        dinleyiciler.add(setTanimlar);
        randevuTanimlariGetir().then(setTanimlar).catch(() => { });
        return () => { dinleyiciler.delete(setTanimlar); };
    }, []);
    const yenile = useCallback(() => randevuTanimlariGetir(true).catch(() => onbellek?.veri ?? null), []);
    return { tanimlar, yenile };
}

// Projeler (form seçimi için)
let projeOnbellek: { projeID: number; projeAdi: string }[] | null = null;
export async function randevuProjeleriGetir() {
    if (projeOnbellek) return projeOnbellek;
    const r = await axiosInstance.get('/api/Projeler');
    projeOnbellek = (r.data as any[]).filter(p => p.aktifMi !== false).map(p => ({ projeID: p.projeID, projeAdi: p.projeAdi }));
    return projeOnbellek;
}
